<svelte:head>
	<!-- <title>Direktorat Jenderal Pengendalian Perubahan Iklim</title> -->
	<!-- <meta name="description" content="Direktorat Jenderal Pengendalian Perubahan Iklim" /> -->
</svelte:head>

<div class="app wrapper-dsbl">
	<main>
		<slot />
	</main>
</div>
